


















import { Component, PropSync, Vue } from 'vue-property-decorator'

@Component
export default class EmailDetailInfoDialog extends Vue {

  @PropSync('show') active!: boolean;
  @PropSync('propMessageContent') messageContent!: string;

}
